import React from 'react';

const NumerarioImportacaoContext = React.createContext();

export default NumerarioImportacaoContext;
